const MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

/**
 * The date a human last confirmed the hours, stamped like the seasonal beach
 * badge every LBI town prints.
 *
 * The API sends an ISO datetime, but a verification has no time of day -- it
 * happened on a day. Feeding it to Date() and formatting in the viewer's zone
 * moves a late-evening check to the next morning in Europe and the previous
 * evening on the west coast, so the date part is read off the string instead.
 */
export function formatVerified(value) {
  if (!value) return null;

  const [year, month, day] = value.slice(0, 10).split('-');

  return { month: MONTHS[Number(month) - 1], day: String(Number(day)), year };
}

export default function Seal({ value }) {
  const parts = formatVerified(value);

  // Never confirmed is a different claim from confirmed a while ago, so it gets
  // a different object. A red seal with a guess in it would undo the only thing
  // on this page worth trusting.
  if (!parts) {
    return (
      <span className="seal seal-none" title="Nobody has confirmed these hours yet">
        <span className="seal-m">Hours</span>
        <span className="seal-d">unchecked</span>
      </span>
    );
  }

  return (
    <span className="seal" title={`Hours confirmed ${parts.month} ${parts.day}, ${parts.year}`}>
      <span className="seal-m">Checked</span>
      <span className="seal-d">
        {parts.month} {parts.day}
      </span>
      <span className="seal-y">{parts.year}</span>
    </span>
  );
}
